import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e7aa128c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e7aa128c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7aa128c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7aa128c')) {
      api.createRecord('e7aa128c', component.options)
    } else {
      api.reload('e7aa128c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e7aa128c&scoped=true", function () {
      api.rerender('e7aa128c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/indexes/sync/index.vue"
export default component.exports